











import {
  defineComponent,
} from '@vue/composition-api';

import CommonFormWithProductCreator from '@/components/Product/CommonFormWithProductCreator.vue';

const UpdateProduct = defineComponent({
  components: {
    CommonFormWithProductCreator,
  },
});

export default UpdateProduct;
